import styled, { css } from 'styled-components';
import { DIMENSIONS } from '@hqo/react-components-library/dist/utils';
import IframeModalWrapper from 'components/modals/iframeWrapper';
import { reverseSlide, slide } from 'hocs/shared-styles';

export const QuickCheckoutWrapper = styled.div<{ kioskMode?: boolean }>`
  background: ${({ theme, kioskMode }) => (!kioskMode ? theme.colors.universal.white : 'transparent')};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 14;
  width: 100%;
  overflow-x: hidden;
  max-width: 100%;

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    width: 100vw;
    border-radius: 8px 8px 0 0;
    transform: translate(0%, 0%);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

export const QuickCheckoutSpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 322px;

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    min-height: 322px;
  }
`;

export const Background = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => `${theme.colorsRgba.black_5}`};
  z-index: 13;
`;

export const ModalContainer = styled.div<{ kioskMode?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${({ kioskMode }) => (kioskMode ? 'unset' : '360px')};
  border-radius: 8px 8px 0 0;

  @media only screen and (max-width: ${DIMENSIONS.LARGE}) {
    align-items: flex-start;
  }

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    height: auto;
    min-height: 322px;
  }
`;

export const StyledModalWrapper = styled(IframeModalWrapper)<{
  reverseAnimation: boolean;
  quickCheckoutHeight: number;
  kioskMode?: boolean;
}>`
  width: 543px;
  max-width: 100%;
  transition: width 1s;

  .iframe-wrapper {
    width: 543px;
    max-width: 100%;
    height: 322px;
  }

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    .iframe-background {
      display: block;
      background-color: ${({ theme }) => `${theme.colorsRgba.black_5}`};
    }

    .iframe-wrapper {
      min-height: 322px;
      max-height: ${props => props.quickCheckoutHeight}px;
      height: auto;
      border-radius: 8px 8px 0 0;
      top: auto;
      animation: ${props => (props.reverseAnimation ? reverseSlide : slide)} 0.5s;
      width: 100%;
      margin: 0;
    }

    .iframe-modal-content {
      border-radius: 8px 8px 0 0;
      height: auto;
      overflow-y: auto;
      overflow-x: hidden;
      padding-bottom: 70px;
      max-width: 100%;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .iframe-modal-content > div {
      border-radius: 8px 8px 0 0;
      height: auto;
    }

    .iframe-modal-content > div > div {
      height: auto;
      transform: none;
      inset: initial;
      position: initial;
      min-height: 322px;
    }
  }

  ${({ kioskMode }) =>
    !kioskMode
      ? css`
          @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
            width: 100%;
          }
        `
      : ''}
`;
